import { GridCell, GridCellProps } from '@mui/x-data-grid-pro';
import { forwardRef, memo } from 'react';

// namespaced prop to avoid collision with mui props
// can props here as needed replacing [key:string]:any
// or prefix props with some unique thing eg 'customOnClick'
// or if need to can direct override mui props...
export interface SearchGridCellProps extends GridCellProps {
  customProps?: {
    [key: string]: any;
  };
}

export const SearchGridCell = memo(
  forwardRef<HTMLDivElement, SearchGridCellProps>(
    ({ customProps, ...muiCellProps }, ref) => {
      return (
        <GridCell
          ref={ref}
          {...muiCellProps}
        />
      );
    },
  ),
);
SearchGridCell.displayName = 'SearchGridCell';
